import dummyFunction from '@/lib/utils/dummyFunction';
import { createContext } from 'react';

const RequestPortfolioItemCloseContext =
  createContext<() => void>(dummyFunction);

export default RequestPortfolioItemCloseContext;
